import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
} from "@chakra-ui/react";
import React from "react";

/**
 * One collapsible section, with a header that looks like a control.
 *
 * Defined once and used by the attestation modals and the note drawer. An accordion
 * header drawn on the same white as the surface behind it reads as a heading rather
 * than something to click, so the tint is not decoration -- it is the only thing
 * saying there is more underneath. Keeping it here rather than repeating the styling
 * at each call site is what stops the three from drifting apart.
 *
 * `header` is a node rather than a string because some sections carry state in the
 * header -- a ruling, a count of chosen actions -- which is what makes a collapsed
 * section safe: nothing that still needs an answer is hidden by being closed.
 */
export default function CollapsibleSection(props: {
  header: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <AccordionItem border="none" mb={2}>
      <AccordionButton
        _expanded={{ bg: "blue.100", borderBottomRadius: 0 }}
        _hover={{ bg: "blue.100" }}
        bg="blue.50"
        borderRadius="md"
        color="blue.900"
        px={4}
        py={3}
      >
        <Box flex="1" textAlign="left">
          {props.header}
        </Box>
        <AccordionIcon />
      </AccordionButton>

      {/* White, not a tint. The header carries the colour so it reads as the control;
          the panel is where someone reads, and text on white is the easiest of it. */}
      <AccordionPanel
        bg="white"
        borderBottomRadius="md"
        borderColor="blue.100"
        borderTopWidth={0}
        borderWidth={1}
        pb={5}
        pt={4}
        px={4}
      >
        {props.children}
      </AccordionPanel>
    </AccordionItem>
  );
}
